{
  "billing": {
    "title": "Fakturierung",
    "page_title": "Abrechnung und Tarife",
    "page_content": "Sie können Ihr Abonnement ändern und verwalten sowie Ihre Zahlungsdetails bearbeiten.",
    "in_arrears_error": {
      "title": "Fehlende oder ungültige Zahlungsmethode",
      "content": "Ihr Konto ist derzeit gesperrt. Bitte aktualisieren Sie Ihre Zahlungsinformationen, um Ihr Konto zu aktivieren"
    },
    "cancelled_error_payed": {
      "title": "Das aktuelle Abonnement ist gekündigt",
      "content_1": "Ihr Konto wurde gekündigt. Bitte",
      "content_2": "kontaktieren Sie uns",
      "content_3": "um dein Konto zu reaktivieren"
    },
    "cancelled_error_trial": {
      "title": "Ihre Testphase ist abgelaufen",
      "content": "Ihr Konto wurde gekündigt. Bitte ändern Sie Ihren Tarif in einen kostenpflichtigen Tarif, um Iventis weiterhin nutzen zu können."
    },
    "subscription_box": {
      "title": "Abonnement",
      "current_plan": "Aktueller Plan",
      "next_payment": "Nächste Zahlung",
      "renews_on": "Erneuert am",
      "paid": "Bezahlt",
      "days": "zum Mitnehmen",
      "get_in_touch": "Nehmen Sie Kontakt mit uns auf, um Ihren Plan zu besprechen",
      "Trial": "Versuch",
      "Active": "Aktiv",
      "Cancelled": "Storniert",
      "InArrears": "Im Nachhinein"
    },
    "change_plan": "Plan ändern",
    "payment_details_box": {
      "title": "Einzelheiten zur Zahlung",
      "payment_method": "Methode der Zahlung",
      "card_ending": "Karte mit den Endziffern",
      "expires": "Läuft ab",
      "billing_address": "Rechnungsadresse",
      "no_payment_method": "Keine Zahlungsmethode",
      "payment_breakdown_project": "{{ amount }} (1 Projekt x {{ amount }}",
      "payment_breakdown_users": "{{ totalAmount }} {{ maxUsers }} Benutzer x {{ userAmount }}",
      "payment_breakdown_user": "{{ totalAmount }} (1 Benutzer x {{ totalAmount }}",
      "users": "Benutzer",
      "user": "Benutzer",
      "discount": "Rabatt"
    },
    "redirect_modal": {
      "title": "Zahlungsmethode bearbeiten",
      "content": "Sie werden zu unserem Abrechnungsanbieter weitergeleitet, um Ihre Zahlungsdetails zu bearbeiten."
    },
    "excludes_taxes": "Schließt alle anfallenden Steuern aus"
  },
  "upgrade_plan_warnings": {
    "upgrade_plan": "Upgrade-Plan",
    "contact_us": "Kontaktiere uns",
    "view_plans": "Pläne ansehen"
  },
  "view_plans": "Pläne ansehen",
  "subscription_details": {
    "title": "Einzelheiten zum Abonnement",
    "selected_plan": "Ausgewählter Plan",
    "plan_type": "Typ des Plans",
    "currency": "Währung",
    "billed": "In Rechnung gestellt",
    "payment_date": "Datum der Zahlung",
    "payment_date_desc": {
      "Monthly": "{{ date }} eines jeden Monats",
      "Annually": "{{ date }}"
    },
    "renewal_date": "Datum der Verlängerung",
    "add_users": "Nutzer hinzufügen",
    "add_payment_method": "Zahlungsmethode hinzufügen",
    "cannot_switch_from_annual": "Bitte kontaktieren Sie uns, wenn Sie von der jährlichen zur monatlichen Abrechnung wechseln möchten",
    "exceeded_max_users_message": "Bitte kontaktieren Sie uns, um Ihre Anforderungen zu besprechen, falls Sie mehr als {{ numberOfUsers }} Benutzer benötigen",
    "continue_to_payment": "Fahren Sie mit der Zahlung fort",
    "redirect_modal": {
      "title": "Abonnement bearbeiten",
      "message": "Wenn Sie auf Weiter klicken, werden Sie zu unserem Abrechnungsanbieter weitergeleitet, um alle erforderlichen Zahlungen für das aktualisierte Abonnement zu leisten"
    },
    "update_successful": "Das Abonnement wurde erfolgreich aktualisiert"
  },
  "subscription_price_breakdown": {
    "title": "Aufschlüsselung des Preises",
    "subscription_fee": "Abonnementgebühr",
    "individual_price_breakdown": "Individuelle Preisaufschlüsselung",
    "discount_applied": "Rabatt angewendet",
    "discount_has_been_applied": "Ein {{ discount }} -Rabatt wurde automatisch auf Ihr Konto angewendet",
    "total": "Insgesamt",
    "frequency_proice_breakdown": "{{ frequency }} Preisaufschlüsselung",
    "frequency": {
      "Monthly": "Monatlich",
      "Annually": "Jährlich"
    },
    "time_unit": {
      "Monthly": "Monate",
      "Annually": "Jahr"
    },
    "users": "Benutzer",
    "excludes_taxes": "Schließt alle anfallenden Steuern aus, die auf der Zahlungsseite hinzugefügt werden"
  },
  "subscription_payment_breakdown": {
    "title": "Aufschlüsselung der Zahlung",
    "vat": "Mehrwertsteuer {{ percentage }} auf {{ total }}",
    "total_excluding_tax": "Summe ohne Steuern",
    "amount_due": "Fälliger Betrag",
    "description": "Beschreibung",
    "total": "Insgesamt",
    "unit": "Einheit",
    "pay": "Zahlen Sie {{ amount }}"
  },
  "order_summary": "Zusammenfassung der Bestellung",
  "settings": "Einstellungen"
}